module.exports = __webpack_public_path__ + "static/media/MOB.f6c6cffc.png";